// extracted by mini-css-extract-plugin
export var animate = "typetext-module--animate--Clks8";
export var blink = "typetext-module--blink--7zYmg";